exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._119IHX090KBUbrb2Uae4rH {\n  content: \"\";\n  border-left: 1px dotted #7e8285;\n  margin: 0 20px;\n  height: 35px; }\n", ""]);

// exports
exports.locals = {
	"header": "_119IHX090KBUbrb2Uae4rH"
};